import React from 'react';
import { Button, DomainIcon, Text } from '@billda/design-system';

interface EmptyStateSitesProps {
  message?: string;
  showImportButton?: boolean;
  onImportClick?: () => void;
}

export const EmptyStateSites: React.FC<EmptyStateSitesProps> = ({
  message = 'No sites found',
  showImportButton = false,
  onImportClick,
}) => {
  return (
    <div className="flex flex-col items-center justify-center px-4 py-8 text-center">
      <DomainIcon
        className="mb-4 size-16 text-content-disabled"
        aria-hidden="true"
      />
      <Text variant="h6" color="secondary" className="mb-2">
        {message}
      </Text>
      {showImportButton && (
        <Button variant="neutral" onClick={onImportClick} className="mt-4">
          Import Site
        </Button>
      )}
    </div>
  );
};
